
<div class="flex flex-row items-center slider">
    <mat-icon matRipple [matRippleCentered]="true" [matRippleRadius]="25" class="shrink-0 arrow-icon cursor-pointer" svgIcon="left-arrow" (click)="carousel.prev()"></mat-icon>
    <div class="flex-auto slider-template justify-center">
        <owl-carousel-o class="owl-slider-item" [options]="carouselOptions" appOwlPreventClick #carousel>
            <ng-template *ngFor="let category of categories"  carouselSlide>
                <a class="category-item mb-3 rounded-xl overflow-hidden" appclick  [routerLink]="['/category', category.seo?.slug]">
                    <div class="thumbnail relative">
                        <div class="overlay absolute h-full w-full z-10 "></div>
                        <img [src]="category?.thumbnail?.url" loading="lazy" [alt]="translateHelper.localize(category.name)">
                    </div>
                    <div class="details" [style.background]="bgColor"  [style.color]="fgColor">
                            <div class="title" [style.color]="fgColor">{{translateHelper.localize(category.name)}}</div>
                    </div>
                </a>
            </ng-template>
        </owl-carousel-o>
    </div>
    <mat-icon matRipple [matRippleCentered]="true" [matRippleRadius]="25" class="shrink-0 arrow-icon cursor-pointer" svgIcon="right-arrow" (click)="carousel.next()"></mat-icon>
</div>
